import LoyaltyOffers from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-offers';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default LoyaltyOffers;
